module.exports = __webpack_public_path__ + "img/thumbnail-header-30.9f1a6d6.jpg";